import type { PageCard } from '@/play/pageTypes'
import { SpillAgainCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'spill-again',
  number: 19,
  title: 'Spill',
  question: 'Does pouring lots of coloured water over a landscape, and steering it, feel good?',
  status: 'open',
  accent: '#bfe3f7',
  CardArt: SpillAgainCardArt,
}
